import { render, staticRenderFns } from "./ConfiguracionComponent.vue?vue&type=template&id=6a74ebe2&scoped=true&"
import script from "./ConfiguracionComponent.vue?vue&type=script&lang=ts&"
export * from "./ConfiguracionComponent.vue?vue&type=script&lang=ts&"
import style0 from "./ConfiguracionComponent.vue?vue&type=style&index=0&id=6a74ebe2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a74ebe2",
  null
  
)

export default component.exports